<mat-spinner mode="indeterminate" diameter="{{size}}"></mat-spinner>